import React from 'react';
import { Snackbar as MuiSnackbar, Alert, Box } from '@mui/material';

const CustomSnackbar = ({ 
  open, 
  message, 
  severity = 'success', 
  onClose, 
  autoHideDuration = 6000,
  action = null
}) => {
  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        onClose={onClose} 
        severity={severity}
        sx={{ width: '100%' }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <span>{message}</span>
          {action && (
            <Box ml={2}>
              {action}
            </Box>
          )}
        </Box>
      </Alert>
    </MuiSnackbar>
  );
};

export default CustomSnackbar;

